import "core-js/modules/es.array.push.js";
import "core-js/modules/es.json.parse.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
var Base64 = require('js-base64').Base64;
import { queryRepairAppoint } from '@/api/repairs/repairsApi.js';
export default {
  data: function data() {
    return {
      form: {
        time: [],
        repairsStatus: undefined,
        queryStr: undefined,
        startTime: '',
        endTime: '',
        repairStatus: ''
      },
      // paginationTable: {
      //     total: 0,
      //     defaultPageSize: 10,
      //     current: 1,
      //     pageSize: 10,
      //     showTotal: total => `共 ${total} 条数据`,
      //     showSizeChanger: true,
      //     pageSizeOptions: ['10', '15', '20'],
      //     onShowSizeChange: this.onShowSizeChange,
      //     onChange: this.pageChange
      // },
      paginationTable: this.$hdk.page(),
      tableData: [],
      loading: false,
      columns: [{
        title: '报修单号',
        dataIndex: 'number',
        key: 'number'
      }, {
        title: '报修时间',
        dataIndex: 'reDate',
        key: 'reDate'
      }, {
        title: '联系电话',
        dataIndex: 'phone',
        key: 'phone'
      }, {
        title: '使用部门',
        dataIndex: "userDepartment",
        ellipsis: true
        // scopedSlots: { customRender: 'drafterTemp' }
      }, {
        title: '物品名称',
        dataIndex: 'itemName',
        key: 'itemName',
        ellipsis: true
      }, {
        title: '故障地点',
        dataIndex: 'location',
        key: 'location',
        ellipsis: true
      }, {
        title: '故障描述',
        dataIndex: 'description',
        key: 'description',
        ellipsis: true
      }, {
        title: '维修状态',
        dataIndex: 'repairsStatus',
        key: 'repairsStatus',
        scopedSlots: {
          customRender: 'repairsStatus'
        }
      }, {
        title: '操作',
        dataIndex: 'operation',
        key: 'operation',
        align: 'center',
        scopedSlots: {
          customRender: 'operation'
        }
      }],
      addRigisterStatus: false,
      addForm: {
        createPerson: undefined
      },
      previewShow: false,
      previewSrc: '',
      viewRigisterStatus: false,
      viewCardBodyStyle: {
        height: '31.25rem'
      }
    };
  },
  created: function created() {
    var savedPagination = sessionStorage.getItem('Pagination_order');
    if (savedPagination) {
      try {
        var parsed = JSON.parse(savedPagination);
        this.paginationTable.current = parsed.current || 1;
        this.paginationTable.pageSize = parsed.pageSize || 10;
      } catch (e) {} finally {}
    }
    this.getQueryRepairAppoint();
  },
  methods: {
    /**
     *提交筛选查询
     */
    search: function search() {
      this.paginationTable.current = 1;
      this.paginationTable.pageSize = 10;
      this.getQueryRepairAppoint();
      sessionStorage.removeItem('Pagination_order');
    },
    /**
     *切换分页时调用
     */
    change: function change(pagination) {
      this.getQueryRepairAppoint({
        current: pagination.current,
        pageSize: pagination.pageSize,
        form: this.form
      });
      sessionStorage.setItem('Pagination_order', JSON.stringify(pagination));
    },
    /**
     *查询列表信息
     */
    getQueryRepairAppoint: function getQueryRepairAppoint(options) {
      var _this = this;
      var paginationTable = this.paginationTable,
        form = this.form,
        pager = _.assign({}, paginationTable, options);
      this.loading = true;
      if (this.form.time.length > 0) {
        this.form.startTime = this.form.time[0];
        this.form.endTime = this.form.time[1];
      } else {
        this.form.startTime = null;
        this.form.endTime = null;
      }
      if (!pager.form) {
        pager.form = form;
      }
      // return;
      queryRepairAppoint(pager.current, pager.pageSize, pager.form).then(function (res) {
        _this.tableData = res.data.data;
        _.assign(paginationTable, {
          total: res.data.count,
          current: pager.current,
          pageSize: pager.pageSize
        });
        _.assign(form, pager.form);
      }).finally(function () {
        _this.loading = false;
      });
    },
    // addRigister() {
    //     this.addRigisterStatus = true;
    // },
    // addRigisterSubmit() {
    //     this.addRigisterStatus = false;
    // },
    // addRigisterCancel() {
    //     this.addRigisterStatus = false;
    //     this.$refs.addForm.resetFields();
    // },
    // handleChangeUpload(info) {
    //     if (info.file.status == 'removed') {
    //         this.$message.success('删除');
    //         this.addForm.fileList = info.fileList;
    //         this.previewSrc = '';
    //         this.previewShow = false;
    //         return;
    //     }
    //     if (!info.file.name.includes('.jpg') && !info.file.name.includes('.png')) {
    //         this.$message.error('请上传正确格式');
    //         return;
    //     }
    //     this.addForm.fileList = info.fileList;
    //     if (info.file.response) {
    //         if (info.file.response.code == 200) {
    //             this.addForm.fileList = info.fileList;
    //             this.$message.success('上传成功');
    //         } else {
    //             this.$message.error(info.file.response.message);
    //         }
    //     }
    // },
    // handlePreview(file) {
    //     let url = file.response.data.url;
    //     let fileUrl = config.baseUrl + url;
    //     window.open(config.filePreview + '?url=' + encodeURIComponent(Base64.encode(fileUrl)), '_blank');
    //     this.previewShow = true;
    //     this.previewSrc =
    //         config.filePreview + '?url=' + encodeURIComponent(Base64.encode(fileUrl));
    // },
    // handleCancel() {
    //     this.previewShow = false;
    // },
    /**
     * 查看跳转
     */
    viewRigister: function viewRigister(row) {
      this.$router.push({
        path: '/reimburseRepairs/repairs/repairsDetail',
        query: {
          id: row.fillId,
          mode: 'view',
          backTo: 'order'
        }
      });
    },
    /**
     * 反馈跳转
     */
    // feedbackClick(row) {
    //     this.$router.push({
    //         path: '/reimburseRepairs/repairs/repairsDetail',
    //         query: {
    //             id: row.id,
    //             mode: 'feedback',
    //             backTo: 'order'
    //         }
    //     });
    // },
    /**
     * 接单跳转
     */
    orderClick: function orderClick(row) {
      //判断状态为待接单跳转
      if (row.repairsStatus == 3) {
        this.$router.push({
          path: '/reimburseRepairs/repairs/repairsDetail',
          query: {
            id: row.fillId,
            mode: 'order',
            backTo: 'order',
            repairsStatus: row.repairsStatus
          }
        });
      } else if (row.repairsStatus == 5) {
        //判断状态为维修中跳转
        this.$router.push({
          path: '/reimburseRepairs/repairs/repairsDetail',
          query: {
            id: row.fillId,
            mode: 'feedback',
            backTo: 'order',
            repairsStatus: row.repairsStatus
          }
        });
      }
    }
  }
};